<template>
  <div class="noticias-wrapper">
    <header
      class="dashboard-header"
      v-if="!isCoordenacao"
    >
      <div>
        <h2>Análise de notícias</h2>
        <p>Acompanhe e avalie todas as notícias encaminhadas para a PREX.</p>
      </div>
    </header>

    <!-- CARDS DE RESUMO POR STATUS -->
    <ResumoStatusNoticias
      :isCoordenacao="isCoordenacao"
      :contagens="contagensCoordenacao"
      :resumoNoticias="resumoNoticias"
      :filtroAtivo="filtrosNoticias.status"
      @selecionar="selecionarFiltroStatus"
    />

    <!-- PAINEL DE LISTAGEM -->
    <div class="painel-listagem">
      <div class="filtros">
        <div class="campo-busca">
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>
          <input
            v-model="filtrosNoticias.busca"
            type="search"
            placeholder="Buscar por título, autor, ação ou palavra-chave"
            aria-label="Buscar notícias"
            @keyup.enter="aplicarFiltrosNoticias"
          />
        </div>
        <select
          v-model="filtrosNoticias.status"
          aria-label="Filtrar por status"
          @change="aplicarFiltrosNoticias"
        >
          <option value="TODAS">Todos os status</option>
          <template v-if="isCoordenacao">
            <option
              v-for="filtro in filtrosStatusCoordenacao"
              :key="filtro.valor"
              :value="filtro.valor"
            >
              {{ filtro.rotulo }}
            </option>
          </template>
          <template v-else>
            <option value="PENDENTE">Aguardando análise</option>
            <option value="ACEITA">Aceitas</option>
            <option value="REJEITADA">Rejeitadas</option>
          </template>
        </select>
        <button
          type="button"
          class="btn-filtrar"
          @click="aplicarFiltrosNoticias"
        >
          Buscar
        </button>
      </div>

      <!-- Filtros do endpoint autorizar-noticia (só na área PREX) -->
      <div
        v-if="!isCoordenacao"
        class="filtros filtros-avancados"
      >
        <ComboboxPaginado
          v-model="filtrosNoticias.unidadeId"
          label="Unidade"
          placeholder="Todas as unidades"
          :buscarPagina="buscarUnidades"
          @update:modelValue="aplicarFiltrosNoticias"
        />
        <ComboboxPaginado
          v-model="filtrosNoticias.acaoId"
          label="Ação"
          placeholder="Todas as ações"
          :dependencia="filtrosNoticias.unidadeId"
          :buscarPagina="buscarAcoes"
          @update:modelValue="aplicarFiltrosNoticias"
        />
        <ComboboxPaginado
          v-model="filtrosNoticias.autorId"
          label="Autor"
          placeholder="Todos os autores"
          :buscarPagina="buscarUsuarios"
          @update:modelValue="aplicarFiltrosNoticias"
        />
        <ComboboxPaginado
          v-model="filtrosNoticias.autorizadorId"
          label="Analista"
          placeholder="Todos os analistas"
          :buscarPagina="buscarUsuarios"
          @update:modelValue="aplicarFiltrosNoticias"
        />
        <input
          v-model="filtrosNoticias.dataInicial"
          type="date"
          aria-label="Data inicial"
          @change="aplicarFiltrosNoticias"
        />
        <input
          v-model="filtrosNoticias.dataFinal"
          type="date"
          aria-label="Data final"
          @change="aplicarFiltrosNoticias"
        />
        <select
          v-model="filtrosNoticias.sort"
          aria-label="Ordenar por"
          @change="aplicarFiltrosNoticias"
        >
          <option value="dataCadastro,desc">Mais recentes</option>
          <option value="dataCadastro,asc">Mais antigas</option>
          <option value="titulo,asc">Título (A-Z)</option>
          <option value="titulo,desc">Título (Z-A)</option>
        </select>
      </div>

      <!-- Estados da lista -->
      <div
        v-if="loadingNoticias"
        class="estado-lista"
      >
        <span
          class="spinner"
          aria-hidden="true"
        ></span>
        <p>Carregando notícias...</p>
      </div>

      <div
        v-else-if="erroNoticias"
        class="estado-lista erro-lista"
      >
        <i
          class="fa-solid fa-triangle-exclamation"
          aria-hidden="true"
        ></i>
        <p>{{ erroNoticias }}</p>
        <button
          type="button"
          @click="buscarNoticiasPrex"
        >
          Tentar novamente
        </button>
      </div>

      <div
        v-else-if="noticiasFiltradas.length === 0"
        class="estado-lista"
      >
        <i
          class="fa-regular fa-folder-open"
          aria-hidden="true"
        ></i>
        <p>Nenhuma notícia encontrada para os filtros selecionados.</p>
      </div>

      <!-- Tabela -->
      <div
        v-else
        class="tabela-container"
      >
        <table>
          <thead>
            <tr>
              <th>Notícia</th>
              <th>Ação vinculada</th>
              <th>Autor / Coordenador</th>
              <th>Recebida em</th>
              <th>Status</th>
              <th>Analista responsável</th>
              <th><span class="sr-only">Ações</span></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="noticia in noticiasPaginadas"
              :key="noticia.id"
            >
              <td class="celula-solicitacao">
                <div class="noticia-tabela-item">
                  <img
                    v-if="noticia.imagemUrl"
                    :src="noticia.imagemUrl"
                    :alt="noticia.titulo"
                    class="tabela-noticia-thumb"
                  />
                  <div class="noticia-tabela-texto">
                    <strong>{{ noticia.titulo }}</strong>
                    <div
                      class="tags"
                      v-if="
                        (noticia.palavrasChave || noticia.palavrasChaves)
                          ?.length
                      "
                    >
                      <span
                        class="tag"
                        v-for="(palavra, index) in (
                          noticia.palavrasChave || noticia.palavrasChaves
                        ).slice(0, 3)"
                        :key="index"
                      >
                        {{ palavra }}
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                {{
                  noticia.acao || noticia.acaoNome || noticia.nomeAcao || "-"
                }}
              </td>
              <td>
                <span>{{
                  noticia.autorPublicacaoNome || noticia.autorNome || "-"
                }}</span>
                <small
                  v-if="
                    noticia.abrangenciaNome ||
                    noticia.unidadeNome ||
                    noticia.nomeUnidade
                  "
                >
                  {{
                    noticia.abrangenciaNome ||
                    noticia.unidadeNome ||
                    noticia.nomeUnidade
                  }}
                </small>
              </td>
              <td>
                {{
                  formatarData(noticia.dataPublicacao || noticia.dataCadastro)
                }}
              </td>
              <td>
                <span
                  class="status"
                  :class="`status-${classeStatus(noticia)}`"
                >
                  {{ formatarStatus(noticia) }}
                </span>
              </td>
              <td class="celula-analista">
                <template v-if="noticia.autorizadorNome">
                  <i
                    class="fa-solid fa-user-check analista-icone"
                    aria-hidden="true"
                  ></i>
                  {{ noticia.autorizadorNome }}
                </template>
                <span
                  v-else
                  class="sem-analista"
                >
                  <i>Sem analista</i>
                </span>
              </td>
              <td class="celula-acoes">
                <button
                  type="button"
                  class="btn-detalhes"
                  @click="verDetalhes(noticia)"
                >
                  Ver detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginação -->
      <footer
        v-if="!loadingNoticias && totalElementosNoticias > 0"
        class="paginacao"
      >
        <span>
          Exibindo {{ inicioPaginaNoticias }}–{{ fimPaginaNoticias }} de
          {{ totalElementosNoticias }}
        </span>
        <div>
          <button
            type="button"
            :disabled="paginaAtualNoticias === 0"
            aria-label="Página anterior"
            @click="mudarPaginaNoticias(paginaAtualNoticias - 1)"
          >
            ‹
          </button>
          <span
            >Página {{ paginaAtualNoticias + 1 }} de
            {{ totalPaginasNoticias }}</span
          >
          <button
            type="button"
            :disabled="paginaAtualNoticias >= totalPaginasNoticias - 1"
            aria-label="Próxima página"
            @click="mudarPaginaNoticias(paginaAtualNoticias + 1)"
          >
            ›
          </button>
        </div>
      </footer>
    </div>

    <NoticiaViewPrex
      v-if="noticiaDetalheAberta"
      :noticiaId="noticiaDetalheSelecionada?.id"
      :noticiaObjeto="noticiaDetalheSelecionada"
      :mostrarBotoes="mostrarBotoesAnalise(noticiaDetalheSelecionada)"
      @fechar="fecharDetalheNoticia"
      @aceita="onNoticiaAtualizada"
      @rejeitada="onNoticiaAtualizada"
    />
  </div>
</template>

<script setup>
import { defineProps, watch } from "vue";
import ResumoStatusNoticias from "@/components/central-coordenador/noticias/ResumoStatusNoticias.vue";
import {
  normalizarStatusNoticia,
  STATUS_NOTICIA_COORDENACAO_CLASSE,
  STATUS_NOTICIA_COORDENACAO_LABEL,
  FILTROS_STATUS_NOTICIA_COORDENACAO,
} from "@/constants/noticias";

const props = defineProps({
  isCoordenacao: {
    type: Boolean,
    default: false,
  },
  acaoId: {
    type: String,
    default: null,
  },
});
import { ref, reactive, computed, onMounted } from "vue";
const filtrosStatusCoordenacao = FILTROS_STATUS_NOTICIA_COORDENACAO.filter(
  (f) => f.valor !== "TODAS"
);
import { formatarData } from "@/utils/FormatarEntradas";
import noticiaService from "@/service/noticiaService";
import unidadesService from "@/service/unidadesService";
import acaoService from "@/service/acaoService";
import usuariosService from "@/service/usuariosService";
import ComboboxPaginado from "@/components/common/ComboboxPaginado.vue";
import NoticiaViewPrex from "@/views/noticias/NoticiaViewPrex.vue";

const todasNoticiasPrex = ref([]);
const erroNoticias = ref("");
const loadingNoticias = ref(false);
const TAMANHO_PAGINA_NOTICIAS = 10;
// área PREX: paginação, status e contagens vêm do servidor
const totalServidor = ref(0);
const resumoServidor = ref({});
const STATUS_BACKEND_POR_FILTRO = {
  PENDENTE: ["AGUARDANDO_AUTORIZACAO"],
  ACEITA: ["AGENDADA", "PUBLICADA"],
  REJEITADA: ["NAO_AUTORIZADA"],
};
const paginaAtualNoticias = ref(0);

const filtrosNoticias = reactive({
  busca: "",
  status: "TODAS",
  unidadeId: "",
  acaoId: "",
  autorId: "",
  autorizadorId: "",
  dataInicial: "",
  dataFinal: "",
  sort: "dataCadastro,desc",
});

const TAMANHO_BUSCA_COMBO = 10;
const lista = (r) => r?.content ?? (Array.isArray(r) ? r : []);

async function buscarUnidades({ page, busca }) {
  // /unidades/busca: parcial e paginado (sem nome, traz todas)
  const r = await unidadesService.getUnidadesByNome(
    busca,
    page,
    TAMANHO_BUSCA_COMBO
  );
  return {
    itens: lista(r).map((u) => ({ id: u.id, rotulo: u.nome })),
    ultima: r?.last ?? true,
  };
}

// títulos de ações se repetem entre edições; o período diferencia
function rotuloAcao(a) {
  const ano = (d) => (d ? String(d).slice(0, 4) : "");
  const periodo = [ano(a.dataInicio), ano(a.dataFim)].filter(Boolean);
  const sufixo = [...new Set(periodo)].join("–");
  return `${a.titulo || a.nome}${sufixo ? ` (${sufixo})` : ""}`;
}

// com unidade selecionada, só ações dela
async function buscarAcoes({ page, busca }) {
  const r = await acaoService.getAcoesFiltro(
    page,
    TAMANHO_BUSCA_COMBO,
    filtrosNoticias.unidadeId || null,
    null,
    busca || null
  );
  return {
    itens: lista(r).map((a) => ({ id: a.id, rotulo: rotuloAcao(a) })),
    ultima: r?.last ?? lista(r).length < TAMANHO_BUSCA_COMBO,
  };
}

async function buscarUsuarios({ page, busca }) {
  const r = await usuariosService.pesquisarUsuarios(
    page,
    TAMANHO_BUSCA_COMBO,
    busca,
    ""
  );
  return {
    itens: lista(r).map((u) => ({ id: u.id, rotulo: u.nome })),
    ultima: r?.last ?? lista(r).length < TAMANHO_BUSCA_COMBO,
  };
}

const noticiaDetalheAberta = ref(false);
const noticiaDetalheSelecionada = ref(null);

function extrairStatus(noticia) {
  if (props.isCoordenacao) return normalizarStatusNoticia(noticia);
  if (!noticia) return "PENDENTE";

  const status = String(
    noticia.statusDescricao ||
      noticia.statusNome ||
      noticia.tipoStatus ||
      noticia.status ||
      ""
  ).toUpperCase();

  if (
    status.includes("AGUARD") ||
    status.includes("PENDENTE") ||
    noticia.autorizado === null
  ) {
    return "PENDENTE";
  }

  if (
    status.includes("NAO_AUTORIZAD") ||
    status.includes("REJEIT") ||
    status.includes("CANCEL")
  ) {
    return "REJEITADA";
  }

  if (
    noticia.autorizado === true ||
    status.includes("PUBLICAD") ||
    status.includes("AGENDAD") ||
    status.includes("ACEITA")
  ) {
    return "ACEITA";
  }

  if (noticia.autorizado === false) {
    return "REJEITADA";
  }

  return "PENDENTE";
}

function classeStatus(noticia) {
  if (props.isCoordenacao)
    return (
      STATUS_NOTICIA_COORDENACAO_CLASSE[normalizarStatusNoticia(noticia)] ||
      "neutra"
    );
  const st = extrairStatus(noticia);
  if (st === "ACEITA") return "aceita";
  if (st === "REJEITADA") return "rejeitada";
  return "pendente";
}

function formatarStatus(noticia) {
  if (props.isCoordenacao)
    return (
      STATUS_NOTICIA_COORDENACAO_LABEL[normalizarStatusNoticia(noticia)] ||
      "Desconhecida"
    );
  const st = extrairStatus(noticia);
  if (st === "ACEITA") return "Aceita";
  if (st === "REJEITADA") return "Rejeitada";
  return "Pendente";
}

function mostrarBotoesAnalise(noticia) {
  if (props.isCoordenacao) return false;
  if (!noticia) return false;
  return extrairStatus(noticia) === "PENDENTE";
}

function verDetalhes(noticia) {
  noticiaDetalheSelecionada.value = noticia;
  noticiaDetalheAberta.value = true;
}

function fecharDetalheNoticia() {
  noticiaDetalheAberta.value = false;
  noticiaDetalheSelecionada.value = null;
}

const contagensCoordenacao = computed(() => {
  const resultado = { TODAS: todasNoticiasPrex.value.length };
  if (!props.isCoordenacao) return resultado;
  resultado["ENVIADA"] = 0;
  resultado["PROGRAMADA"] = 0;
  resultado["PUBLICADA"] = 0;
  resultado["RECUSADA"] = 0;
  todasNoticiasPrex.value.forEach((noticia) => {
    const st = normalizarStatusNoticia(noticia);
    if (st === "APROVADA" || st === "PROGRAMADA" || st === "ACEITA") {
      resultado["PROGRAMADA"]++;
    } else if (resultado[st] !== undefined) {
      resultado[st]++;
    }
  });
  return resultado;
});

const resumoNoticias = computed(() => {
  if (!props.isCoordenacao) {
    const r = resumoServidor.value;
    const n = (k) => Number(r[k] || 0);
    const aceitas = n("AGENDADA") + n("PUBLICADA");
    return {
      pendentes: n("AGUARDANDO_AUTORIZACAO"),
      aceitas,
      rejeitadas: n("NAO_AUTORIZADA"),
      total: n("AGUARDANDO_AUTORIZACAO") + aceitas + n("NAO_AUTORIZADA"),
    };
  }
  const contagem = { total: 0, pendentes: 0, aceitas: 0, rejeitadas: 0 };
  contagem.total = todasNoticiasPrex.value.length;
  todasNoticiasPrex.value.forEach((noticia) => {
    const st = extrairStatus(noticia);
    if (st === "PENDENTE") contagem.pendentes++;
    else if (st === "ACEITA") contagem.aceitas++;
    else if (st === "REJEITADA") contagem.rejeitadas++;
  });
  return contagem;
});

const noticiasFiltradas = computed(() => {
  if (!props.isCoordenacao) return todasNoticiasPrex.value;
  let lista = [...todasNoticiasPrex.value];

  if (filtrosNoticias.status && filtrosNoticias.status !== "TODAS") {
    lista = lista.filter((n) => {
      const st = extrairStatus(n);
      if (filtrosNoticias.status === "PROGRAMADA" || filtrosNoticias.status === "ACEITA") {
        return st === "PROGRAMADA" || st === "APROVADA" || st === "ACEITA";
      }
      return st === filtrosNoticias.status;
    });
  }

  // na área PREX a busca por título vai para o servidor
  if (props.isCoordenacao && filtrosNoticias.busca.trim()) {
    const termo = filtrosNoticias.busca.trim().toLowerCase();
    lista = lista.filter((n) => {
      const titulo = (n.titulo || "").toLowerCase();
      const autor = (n.autorPublicacaoNome || n.autorNome || "").toLowerCase();
      const autorizador = (n.autorizadorNome || "").toLowerCase();
      const unidade = (
        n.unidadeNome ||
        n.nomeUnidade ||
        n.abrangenciaNome ||
        ""
      ).toLowerCase();
      const acao = (n.acao || n.acaoNome || n.nomeAcao || "").toLowerCase();
      const texto = (n.texto || "").toLowerCase();
      const palavras = Array.isArray(n.palavrasChave || n.palavrasChaves)
        ? (n.palavrasChave || n.palavrasChaves).join(" ").toLowerCase()
        : "";

      return (
        titulo.includes(termo) ||
        autor.includes(termo) ||
        autorizador.includes(termo) ||
        unidade.includes(termo) ||
        acao.includes(termo) ||
        texto.includes(termo) ||
        palavras.includes(termo)
      );
    });
  }

  lista.sort((a, b) => {
    const stA = extrairStatus(a);
    const stB = extrairStatus(b);
    const isPendenteA = stA === "PENDENTE" || stA === "ENVIADA";
    const isPendenteB = stB === "PENDENTE" || stB === "ENVIADA";
    if (isPendenteA && !isPendenteB) return -1;
    if (isPendenteB && !isPendenteA) return 1;

    const dataA =
      a.dataPublicacao || a.dataCadastro
        ? new Date(a.dataPublicacao || a.dataCadastro).getTime()
        : 0;
    const dataB =
      b.dataPublicacao || b.dataCadastro
        ? new Date(b.dataPublicacao || b.dataCadastro).getTime()
        : 0;
    return dataB - dataA;
  });

  return lista;
});

const totalElementosNoticias = computed(() =>
  props.isCoordenacao ? noticiasFiltradas.value.length : totalServidor.value
);
const totalPaginasNoticias = computed(() =>
  Math.max(Math.ceil(totalElementosNoticias.value / TAMANHO_PAGINA_NOTICIAS), 1)
);

const inicioPaginaNoticias = computed(() =>
  totalElementosNoticias.value
    ? paginaAtualNoticias.value * TAMANHO_PAGINA_NOTICIAS + 1
    : 0
);

const fimPaginaNoticias = computed(() =>
  Math.min(
    (paginaAtualNoticias.value + 1) * TAMANHO_PAGINA_NOTICIAS,
    totalElementosNoticias.value
  )
);

const noticiasPaginadas = computed(() => {
  if (!props.isCoordenacao) return noticiasFiltradas.value;
  const inicio = paginaAtualNoticias.value * TAMANHO_PAGINA_NOTICIAS;
  const fim = inicio + TAMANHO_PAGINA_NOTICIAS;
  return noticiasFiltradas.value.slice(inicio, fim);
});

function mudarPaginaNoticias(novaPagina) {
  if (novaPagina < 0 || novaPagina >= totalPaginasNoticias.value) return;
  paginaAtualNoticias.value = novaPagina;
  if (!props.isCoordenacao) buscarNoticiasPrex();
}

function aplicarFiltrosNoticias() {
  paginaAtualNoticias.value = 0;
  if (!props.isCoordenacao) buscarNoticiasPrex();
}

function selecionarFiltroStatus(status) {
  filtrosNoticias.status = status;
  aplicarFiltrosNoticias();
}

function onNoticiaAtualizada() {
  fecharDetalheNoticia();
  buscarNoticiasPrex();
}

async function buscarNoticiasPrex() {
  loadingNoticias.value = true;
  erroNoticias.value = "";
  try {
    let response;
    if (props.isCoordenacao && props.acaoId) {
      response = await noticiaService.getNoticiasAcao(0, 2000, props.acaoId);
    } else if (!props.isCoordenacao) {
      const { busca, status, ...filtros } = filtrosNoticias;
      response = await noticiaService.getAutorizarNoticia(
        paginaAtualNoticias.value,
        TAMANHO_PAGINA_NOTICIAS,
        STATUS_BACKEND_POR_FILTRO[status] ?? [],
        busca.trim(),
        { ...filtros, abrangencia: "PREX" } // área PREX só vê abrangência PREX
      );
      totalServidor.value = response?.totalElements ?? 0;
      resumoServidor.value = response?.resumoStatus ?? {};
    }
    const dados = response?.data || response;
    todasNoticiasPrex.value =
      dados?.content ?? (Array.isArray(dados) ? dados : []);
  } catch (error) {
    console.error("Erro ao buscar notícias:", error);
    erroNoticias.value = "Não foi possível carregar as notícias.";
  } finally {
    loadingNoticias.value = false;
  }
}

watch(
  () => props.acaoId,
  (newVal) => {
    if (props.isCoordenacao && newVal) {
      filtrosNoticias.status = "TODAS";
      buscarNoticiasPrex();
    }
  }
);

onMounted(() => {
  buscarNoticiasPrex();
});

defineExpose({ buscarNoticiasPrex });
</script>

<style scoped>
.noticias-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.dashboard-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--branco);
  margin: 0 0 4px;
}

.dashboard-header p {
  color: var(--roxo-superficie);
  font-size: 0.9rem;
  margin: 0;
}

.painel-listagem {
  overflow: hidden;
  border: 1px solid var(--roxo-superficie);
  border-radius: 15px;
  background: var(--branco);
  box-shadow: 0 6px 20px hsla(258, 55%, 15%, 0.06);
}

.filtros {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--roxo-superficie);
  background: var(--roxo-superficie);
}

.campo-busca {
  position: relative;
  flex: 1;
}

.campo-busca i {
  position: absolute;
  top: 50%;
  left: 14px;
  color: var(--cinza-medio);
  transform: translateY(-50%);
}

.campo-busca input,
.filtros select {
  width: 100%;
  min-height: 42px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 9px;
  color: var(--cinza-escuro);
  background: var(--branco);
  font-size: 0.82rem;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.campo-busca input {
  padding: 9px 14px 9px 40px;
}

.filtros select {
  width: 185px;
  padding: 8px 12px;
}

.campo-busca input:focus,
.filtros select:focus {
  border-color: var(--roxo-claro);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.12);
}

.filtros-avancados {
  flex-wrap: wrap;
  border-top: 1px solid var(--roxo-superficie);
}

.filtros-avancados select,
.filtros-avancados input[type="date"] {
  width: 185px;
  min-height: 42px;
  padding: 8px 12px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 9px;
  color: var(--cinza-escuro);
  background: var(--branco);
  font-size: 0.82rem;
}

.btn-filtrar {
  min-height: 42px;
  padding: 9px 17px;
  border: 1px solid var(--roxo-medio);
  border-radius: 9px;
  color: var(--branco);
  background: var(--roxo-medio);
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-filtrar:hover {
  background: var(--roxo-primario);
}

.tabela-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
}

th {
  padding: 13px 16px;
  color: var(--cinza-medio);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--roxo-superficie);
  font-size: 0.68rem;
}

td {
  max-width: 240px;
  padding: 15px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-escuro);
  vertical-align: middle;
}

tbody tr:hover {
  background: var(--roxo-superficie);
}

td small {
  display: block;
  margin-top: 3px;
  color: var(--cinza-medio);
  font-size: 0.67rem;
}

.celula-solicitacao strong {
  display: block;
  color: var(--roxo-escuro);
  font-size: 0.8rem;
  line-height: 1.35;
}

.noticia-tabela-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tabela-noticia-thumb {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid var(--roxo-superficie);
}

.noticia-tabela-texto {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.noticia-tabela-texto strong {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--roxo-escuro);
  font-size: 0.8rem;
  line-height: 1.35;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.tag {
  padding: 2px 8px;
  background: var(--roxo-superficie);
  border: 1px solid var(--roxo-superficie);
  border-radius: 12px;
  font-size: 0.68rem;
  color: var(--roxo-primario);
  font-weight: 500;
}

.status {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  white-space: nowrap;
}

.status-pendente {
  color: #8a5a00;
  background: #fff1c7;
}

.status-em_analise {
  color: #1a4fa0;
  background: #dbeafe;
}

.status-aguardando_ajustes {
  color: #7a4500;
  background: #ffedd5;
}

.status-aprovada,
.status-publicada {
  color: #12633c;
  background: #dff5e9;
}

.status-programada,
.status-aceita {
  color: #1565c0;
  background: #e3f2fd;
}

.status-reprovada,
.status-rejeitada {
  color: #9d2e39;
  background: #fde4e7;
}

.status-neutra {
  color: #4b5563;
  background: #f3f4f6;
}

.celula-analista {
  font-size: 0.78rem;
  color: #4b4453;
  white-space: nowrap;
}

.analista-icone {
  margin-right: 4px;
  color: #5b3fa8;
  font-size: 0.72rem;
}

.sem-analista {
  color: #a89db5;
  font-style: italic;
  font-size: 0.72rem;
}

.celula-acoes {
  text-align: right;
}

.btn-detalhes {
  padding: 7px 11px;
  border-radius: 8px;
  color: var(--branco);
  background: var(--roxo-primario);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-detalhes:hover {
  color: var(--branco);
  background: var(--roxo-medio);
}

.estado-lista {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px;
  color: var(--cinza-medio);
  text-align: center;
}

.estado-lista i {
  color: var(--roxo-claro);
  font-size: 2rem;
}

.estado-lista p {
  margin: 0;
  font-size: 0.86rem;
}

.estado-lista button {
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  color: var(--branco);
  background: var(--roxo-medio);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid var(--roxo-superficie);
  border-top-color: var(--roxo-medio);
  border-radius: 50%;
  animation: girar 0.8s linear infinite;
}

@keyframes girar {
  to {
    transform: rotate(360deg);
  }
}

.paginacao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-medio);
  font-size: 0.73rem;
}

.paginacao > div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.paginacao button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;
  color: var(--roxo-medio);
  background: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.paginacao button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.paginacao button:hover:not(:disabled) {
  border-color: var(--roxo-medio);
  color: var(--roxo-medio);
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    gap: 12px;
  }

  .filtros {
    flex-wrap: wrap;
  }

  .campo-busca {
    flex: 1 1 100%;
  }

  .filtros select,
  .filtros-avancados select,
  .filtros-avancados input[type="date"] {
    flex: 1 1 140px;
    width: auto;
  }

  .paginacao {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
